/**
 * @generated SignedSource<<755a5201f6deabe89a65aa106d9c538f>>
 * @relayHash 1e00b3cbf494f5818c9909d32e838a60
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 1e00b3cbf494f5818c9909d32e838a60

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "PropositionCommercialeMutationResponse",
    "kind": "LinkedField",
    "name": "propositionCommerciale",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PropositionCommercialeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PropositionCommercialeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "1e00b3cbf494f5818c9909d32e838a60",
    "metadata": {},
    "name": "PropositionCommercialeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "1bb68b4dc39b6f31d84ce9d10b9247f1";

export default node;
